module.exports = __webpack_public_path__ + "static/img/provider-kc.33f20f62.svg";